import(/* webpackMode: "eager", webpackExports: ["FooterFr"] */ "/vercel/path0/src/components/fr/footerFr.comp.tsx");
